<script>
    import { apiURL } from '../../store.js'

    export let teeShirts
    export let color

    let active = teeShirts[0].title
</script>

<div class="allShirts" style="--pageColor: {color}">
    {#each teeShirts as teeShirt}
        <div class="imageWrap" class:active={teeShirt.title == active}>
            <img
                src={apiURL + teeShirt.image.url}
                alt={teeShirt.title}
                on:click={() => { active = teeShirt.title }}
            />
        </div>
    {/each}
</div>
<div class="activeShirt">
    {#each teeShirts.filter(teeShirt => teeShirt.title == active) as teeShirt}
        <div class="image">
            <img src={apiURL + teeShirt.image.url} alt="selected shirt" />
        </div>
        <div class="text">
            <p class="title">
                {teeShirt.title} — {teeShirt.year}
            </p>
            <p class="caption">
                {teeShirt.caption == '' ? 'This t-shirt needs a caption' : teeShirt.caption}
            </p>
            {#if teeShirt.related_papers.length != 0}
                {#each teeShirt.related_papers as related_paper}
                    {#if related_paper.full_paper.length != 0}
                        {#if related_paper.full_paper[0].type == 'Link'}
                            <p class="readMore">
                                Read More:
                                <a target="_blank" href={related_paper.full_paper[0].value}>
                                    {related_paper.title}
                                </a>
                            </p>
                        {:else}
                            <p class="readMore">
                                Read More:
                                <a target="_blank" href="{apiURL}{related_paper.full_paper[0].value.url}">
                                    {related_paper.title}
                                </a>
                            </p>
                        {/if}
                    {/if}
                {/each}
            {/if}
        </div>
    {/each}
</div>

<style lang="scss">
    @import "../../styles/vars";

    .activeShirt {
        margin: 0.75rem 0;

        .title {
            font-family: "Ysabeau";
            font-weight: bold;
            font-size: 1.2rem;
        }

        .text {
            width: 100%;
            font-family: "Ysabeau";
            margin-bottom: 2rem;

            p {
                margin: 0;
            }
        }
        .image {
            width: 100%;
            position: relative;
            margin-bottom: 2rem;

            img {
                height: auto;
                width: 100%;
                margin: 0 auto;
                bottom: 0;
            }
        }
    }

    @include respond-to(phone) {
        .activeShirt {
            row-gap: 1rem;

            .text {
                grid-column: span 5;
            }

            .image {
                grid-column: span 5;
            }
        }
    }

    .allShirts {
        border: 2px solid var(--pageColor);
        padding: 0.75rem;
        display: grid;
        margin-bottom: 2rem;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        column-gap: 0.5rem;
        row-gap: 0.5rem;

        .imageWrap {
            width: 100%;
            height: 0;
            padding-bottom: 100%;
            position: relative;
            opacity: 0.6;
            transition: 0.4s ease opacity;

            &.active {
                opacity: 1;
            }

            &:hover {
                cursor: pointer;
                opacity: 1;
            }
        }

        img {
            position: absolute;
            top:0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
</style>
